import { Button, Col, Divider, Form, Progress, Row, Typography } from "antd"
import { useContainerInjection } from "../../hooks/useContainerInjection"
import { observer } from "mobx-react"
import { useTranslation } from "react-i18next"
import { Card } from "../../styledComponents/CustomCard/Card"
import { DownloadOutlined } from "@ant-design/icons"
import { colors } from "../../assets/styles/appStyles"
import { useState } from "react"
import { CustomBasicSelector as Selector } from "../../components/CustomSelectors/CustomBasicSelector"
import { InvoiceStatus } from "../../../domain/enum/invoiceStatus.enum"
import { UploadProgressStatus } from "../../../domain/enum/uploadProgressStatus.enum"
import { InvoicesFilter } from "../../../domain/types/billing/InvoicesFilter"
import useUpdateEffect from "../../hooks/useUpdateEffect"
import { FormField } from "../../components/Form/FormField"
import { InputType } from "../../components/TextInput/const/InputType.enum"
import { PaymentsViewModel } from "./PaymentsViewModel"
import PaymentsTable from "./components/PaymentsTable"
import PaymentsSearchFilter from "./components/PaymentsSearchFilter"

const { Title } = Typography

const PaymentsView = () => {
	const { t } = useTranslation("billing")
	const viewModel = useContainerInjection<PaymentsViewModel>("PaymentsViewModel")
	const [filter, setFilter] = useState<InvoicesFilter>({ offset: 0, limit: viewModel.limit })

	useUpdateEffect(() => {
		viewModel.fetchInvoices(filter)
	}, [filter])

	return (
		<>
			<div className="tabled">
				<Row gutter={[24, 0]}>
					<Col xs={24} xl={24}>
						<Card
							bordered={false}
							className="criclebox tablespace mb-24"
							title={
								<div className="flex items-center justify-between">
									<Title className="mt-3" level={4}>
										{t("title")}
									</Title>
									<Button
										icon={<DownloadOutlined />}
										type="link"
										disabled={viewModel.isLoading}
										style={viewModel.isLoading ? { color: colors.activity } : undefined}
										onClick={() => viewModel.exportInvoicePayments(filter)}
									>
										{t("export")}
									</Button>
								</div>
							}
						>
							<div className="flex flex-column pt-4 items-center">
								<PaymentsSearchFilter onChange={values => setFilter({ ...filter, ...values })} />
								<Progress
									className={viewModel.isLoading ? "animate-pulse" : "invisible"}
									percent={100}
									status={UploadProgressStatus.LOADING}
									size="small"
									showInfo={false}
								/>
								<Divider className="m-0" />
							</div>
							<PaymentsTable
								data={viewModel.invoices}
								loading={viewModel.isLoading}
								onChangePage={(page, pageSize, lastPageFetched) => {
									if (page >= lastPageFetched - 1 && viewModel.hasNextPage && !viewModel.isFetching) {
										if (viewModel.pagination > 1 && viewModel.limit !== 200) {
											viewModel.setLimit(200)
											viewModel.setPagination(0)
											return
										}
										viewModel.setPagination(viewModel.pagination + 1)
									}
								}}
								isFetching={viewModel.isFetching}
							/>
						</Card>
					</Col>
				</Row>
			</div>
		</>
	)
}

export default observer(PaymentsView)
